<div class="h-[calc(100vh-56px)] min-w-full block">
  <div class="select-region flex justify-end gap-3 w-full relative">
    <p-dropdown
      [options]="regions"
      [(ngModel)]="selectedRegion"
      placeholder="Select region"
      optionLabel="country_name"
      (ngModelChange)="onChangeRegion()"
      styleClass="pl-2"
    >
      <ng-template pTemplate="selectedItem">
        <div class="flex align-items-center gap-2" *ngIf="selectedRegion">
          <span class="text-sm font-medium text-gray-700"
          >{{
              "section-shop-management.region" | translate | sentenceCase
            }}:</span
          >
          <div>{{ selectedRegion?.country_name }}</div>
        </div>
      </ng-template>
    </p-dropdown>
  </div>
  <div
    *ngIf="isLoading"
    class="card flex justify-center items-center h-[600px] min-w-full"
  >
    <p-progressSpinner ariaLabel="loading" />
  </div>

  <iframe
    [src]="safeUrl"
    width="100%"
    height="100%"
    [style.visibility]="isLoading ? 'hidden' : 'visible'"
    (load)="onIframeLoad()"
  ></iframe>
</div>
